/**
 * Íconos de línea, monocromáticos (toman el color del texto con `currentColor`), dibujados en una
 * cuadrícula de 24 × 24 con trazo uniforme. Propios del panel: sin dependencias externas.
 */
const PATHS = {
  home: ['M3 11 12 3l9 8', 'M5 9.5V20h14V9.5', 'M10 20v-6h4v6'],
  chart: ['M3 20h18', 'M6 16v-4', 'M11 16V7', 'M16 16v-6', 'M21 16v-2'],
  inbox: ['M3 13h5l1.5 3h5l1.5-3h5', 'M3 13l2.5-8h13L21 13v6H3z'],
  funnel: ['M3 4h18l-7 8.5V19l-4 2v-8.5z'],
  check: ['M4 4h16v16H4z', 'M8 12.5l2.8 2.8L16 9.5'],
  cart: ['M3 4h2l2.4 11h11L21 7H6', 'M9 19.5h.01', 'M17 19.5h.01'],
  file: ['M6 3h8l4 4v14H6z', 'M14 3v4h4', 'M9 12h6', 'M9 16h6'],
  fileCheck: ['M6 3h8l4 4v14H6z', 'M14 3v4h4', 'M9 14.5l2 2 4-4'],
  card: ['M3 6h18v12H3z', 'M3 10h18', 'M7 15h3'],
  receipt: ['M6 3h12v18l-3-2-3 2-3-2-3 2z', 'M9 8h6', 'M9 12h6'],
  undo: ['M9 14 4 9l5-5', 'M4 9h11a5 5 0 0 1 0 10h-3'],
  user: ['M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M4.5 21a7.5 7.5 0 0 1 15 0'],
  users: [
    'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z',
    'M2.5 20a6.5 6.5 0 0 1 13 0',
    'M16 4.3a3.5 3.5 0 0 1 0 6.4',
    'M18 14.2a6.5 6.5 0 0 1 3.5 5.8',
  ],
  box: ['M12 3 3 7.5v9L12 21l9-4.5v-9z', 'M3 7.5 12 12l9-4.5', 'M12 12v9'],
  tag: ['M3 12V4h8l10 10-8 8z', 'M7.5 8.5h.01'],
  pin: [
    'M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z',
    'M12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
  ],
  plan: ['M3 3h18v18H3z', 'M3 9h7', 'M14 9h7', 'M10 3v6', 'M3 15h10', 'M17 15v6'],
  list: ['M9 6h12', 'M9 12h12', 'M9 18h12', 'M4 6h.01', 'M4 12h.01', 'M4 18h.01'],
  layers: ['M12 3 2 8l10 5 10-5z', 'M2 13l10 5 10-5', 'M2 17.5l10 5 10-5'],
  history: ['M3.5 12a8.5 8.5 0 1 0 2.5-6', 'M3 4v4.5h4.5', 'M12 7.5V12l3 2'],
  sliders: [
    'M4 6h9',
    'M17 6h3',
    'M13 4v4',
    'M4 12h3',
    'M11 12h9',
    'M7 10v4',
    'M4 18h11',
    'M19 18h1',
    'M15 16v4',
  ],
  transfer: ['M4 8h15', 'M15 4l4 4-4 4', 'M20 16H5', 'M9 12l-4 4 4 4'],
  clipboard: ['M9 3h6v3H9z', 'M8 4.5H5V21h14V4.5h-3', 'M9 13.5l2 2 4-4'],
  warehouse: ['M3 21V9l9-5 9 5v12', 'M7 21v-8h10v8', 'M7 17h10'],
  truck: ['M2 6h12v10H2z', 'M14 10h4l3 3v3h-7', 'M6 18.5h.01', 'M17 18.5h.01'],
  building: ['M4 21V4h10v17', 'M14 9h6v12', 'M3 21h18', 'M8 8h2', 'M8 12h2', 'M8 16h2'],
  bank: ['M3 9.5 12 4l9 5.5', 'M5 10v8', 'M9.5 10v8', 'M14.5 10v8', 'M19 10v8', 'M3 20.5h18'],
  wallet: ['M3 7h17v13H3z', 'M3 7l13-3v3', 'M16 13.5h2'],
  book: [
    'M2 5h7a3 3 0 0 1 3 3v12a2.5 2.5 0 0 0-2.5-2.5H2z',
    'M22 5h-7a3 3 0 0 0-3 3v12a2.5 2.5 0 0 1 2.5-2.5H22z',
  ],
  percent: [
    'M19 5 5 19',
    'M7 9.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
    'M17 19.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
  ],
  company: ['M3 21h18', 'M5 21V7l7-4 7 4v14', 'M9 21v-5h6v5', 'M9 10h.01', 'M15 10h.01'],
  mail: ['M3 5h18v14H3z', 'M3 6l9 7 9-7'],
  bell: ['M6 16v-5a6 6 0 0 1 12 0v5l1.5 2h-15z', 'M10 20.5a2 2 0 0 0 4 0'],
  calendar: ['M4 6h16v15H4z', 'M4 10h16', 'M8 3v5', 'M16 3v5', 'M8 14h3', 'M8 17.5h3'],
  plug: ['M9 3v5', 'M15 3v5', 'M6 8h12v3a6 6 0 0 1-12 0z', 'M12 17v4'],
  shield: ['M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z'],
  lock: ['M5 11h14v10H5z', 'M8 11V8a4 4 0 0 1 8 0v3'],
  swap: ['M12 3v12', 'M7.5 10.5 12 15l4.5-4.5', 'M5 21h14'],
  gauge: ['M12 14l4-4', 'M3.5 18a9 9 0 1 1 17 0'],
  key: ['M8 19a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M11 12l9-9', 'M17 6l3 3', 'M14.5 8.5l2 2'],
  chat: ['M21 12a8.5 8.5 0 0 1-12.3 7.6L3 21l1.4-5A8.5 8.5 0 1 1 21 12z'],
  bot: ['M5 8h14v12H5z', 'M12 4v4', 'M12 3h.01', 'M9.5 13h.01', 'M14.5 13h.01', 'M9.5 16.5h5'],
  sparkle: ['M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z', 'M19 15v4', 'M17 17h4'],
  send: ['M12 19V5', 'M5.5 11.5 12 5l6.5 6.5'],
  refresh: ['M20 12a8 8 0 1 1-2.4-5.7', 'M20 4v4.5h-4.5'],
  link: [
    'M10 13.5a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7',
    'M14 10.5a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7',
  ],
  activity: ['M3 12h4l3-8 4 16 3-8h4'],
  help: [
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
    'M9.5 9a2.6 2.6 0 1 1 3.6 2.4c-.7.3-1.1.9-1.1 1.6v.5',
    'M12 17h.01',
  ],
  lifebuoy: [
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
    'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
    'M5.6 5.6l3.6 3.6',
    'M14.8 14.8l3.6 3.6',
    'M14.8 9.2l3.6-3.6',
    'M5.6 18.4l3.6-3.6',
  ],
  settings: [
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    'M12 2.5v3',
    'M12 18.5v3',
    'M4.9 4.9 7 7',
    'M17 17l2.1 2.1',
    'M2.5 12h3',
    'M18.5 12h3',
    'M4.9 19.1 7 17',
    'M17 7l2.1-2.1',
  ],
  server: ['M3 4h18v6H3z', 'M3 14h18v6H3z', 'M7 7h.01', 'M7 17h.01'],
  chevron: ['M9 6l6 6-6 6'],
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  size = 18,
  className,
}: {
  name: IconName;
  size?: number;
  className?: string;
}) {
  return (
    <svg
      className={className ? `icon ${className}` : 'icon'}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
    >
      {PATHS[name].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
